import styled from 'styled-components';
import { sizes } from 'style';

export const ThanksContainer = styled.div`
  display: flex;
  flex-direction: column;

  > * {
    flex: 1;
  }

  @media ${sizes.desktop} {
    flex-direction: row;
    align-items: center;
  }
`;

export const LeftCol = styled.div`
  max-width: 600px;

  > h1 {
    margin-bottom: 40px;
  }
  > p {
    margin-bottom: 20px;
  }
`;

export const ReviewLogo = styled.img`
  height: 16px;
  margin-right: 10px;
  vertical-align: text-top;
`;

export const Buttons = styled.div`
  display: flex;
  flex-direction: column;
  width: 285px;
  margin-top: 40px;

  > * {
    flex: 1;
    margin-bottom: 20px;

    > svg {
      margin-right: 10px;
      vertical-align: text-top;
    }
  }
`;

export const ImageContainer = styled.div`
  margin: 0 auto;
  max-width: 700px;

  > img {
    width: 100%;
    height: auto;
  }
`;
